export default "__VITE_ASSET__25df8f1b__"